import CheckerJobList from './CheckerJobList';
import CheckerJobShow from './CheckerJobShow';
import NetworkCheckIcon from '@material-ui/icons/NetworkCheck';

export default {
  list: CheckerJobList,
  show: CheckerJobShow,
  icon: NetworkCheckIcon,
};
